import Node from './node'; 
import Edge from './edge';
import Group from './group';
import diff from './diff'; 
import {addNodesCom , addEdgesCom , addGroupsCom} from './add-com';

// treeNode还没有使用起来。待解决
const process = ({ nodes = [], edges = [], groups = [] }) => {
  let BaseNode = Node; 
  return {
    nodes: nodes.map((node) => {
      return {
        ...node,
        Class: BaseNode,
      };
    }),
    edges: edges.map(edge => {
      return {
        type: 'endpoint',
        ...edge,
        Class: Edge,
      };
    }),
    groups: groups.map(group => {
      return {
        ...group,
        Class: Group,
      };
    })
  };
};
 
const processNodes = (canvas, nodes, oldNodes, parent) => { 

  const { created, deleted } = diff(nodes, oldNodes);

  canvas.removeNodes(deleted.map(e => e.id), true);

  canvas.addNodes(process({nodes: created}).nodes);
  
  addNodesCom(canvas.getDataMap().nodes,{nodes: created}.nodes, parent);

};

const processEdge = (canvas, edges, oldEdges, parent) => {
  const { created, deleted } = diff(edges, oldEdges);

  canvas.removeEdges(deleted.map(e => e.id), true);

  canvas.addEdges(process({edges: created}).edges, true);
  
  addEdgesCom({edges: created}.edges, parent);
};

const processGroups = (canvas, groups, oldGroups, parent) => {
  const {created, deleted} = diff(groups, oldGroups);

  process({groups: deleted}).groups.forEach(group => {
    canvas.removeGroup(group.id);
  });

  process({groups: created}).groups.forEach(group => {
    canvas.addGroup(group);
  });

  addGroupsCom({groups: created}.groups, parent);
};

export {
  process,
  processNodes,
  processEdge,
  processGroups
};
